var React = require('react');

function Upload (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("g",{"fill":"none","stroke":"#fff","strokeLinecap":"round","strokeWidth":"1.6","data-name":"Group 736","key":1},[React.createElement("path",{"strokeMiterlimit":"10","d":"M13.555 17.746h0s.872-.012 2.536 0a1.608 1.608 0 001.655-1.655V2.455A1.655 1.655 0 0016.091.8H2.455A1.655 1.655 0 00.8 2.455v13.636a1.655 1.655 0 001.655 1.655h2.2","data-name":"Path 572","key":0}),React.createElement("path",{"strokeLinejoin":"round","d":"M5.55 10.1l3.924-4.167 3.845 4.167","data-name":"Path 574","key":1}),React.createElement("path",{"d":"M9.435 5.932v14.793","data-name":"Path 793","key":2})])]);
}

Upload.defaultProps = {"viewBox":"0 0 18.546 21.525"};

module.exports = Upload;

Upload.default = Upload;
